/* eslint-disable max-len */
import React from 'react';

const downIcon = props => (
  <svg fill="currentColor" width="23px" height="11px" viewBox="17 0 39 35" {...props}>
    <g>
      <path d="m31.4 24.3q0 0.6-0.5 1l-10 10q-0.4 0.4-1 0.4t-1-0.4l-10-10q-0.4-0.4-0.4-1t0.4-1 1-0.4h20q0.6 0 1 0.4t0.5 1z" />
    </g>
  </svg>
);

export default downIcon;
